// import ChangeLog from './changelog.json'


//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'

import { Data as BasicContent } from './api/basic/index'
import { Data as MarketContent } from './api/market/index'
import { Data as TradeContent } from './api/trade/index'
import Introduce from './1_introduce.json'
import Description from './2_description.json'
import { List as SocketContent } from './websocket/index'



// import Socket from './websocket/websocket.json'
const ROOT_MODULE = "zh-tw/cswap"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "常見問題",
  "content": QandAContent
}
export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket 文檔",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "變更日誌",
  "content": ChangeLogContent
}

const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "簽名認證",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "基礎信息",
  "content": BasicContent
}

const Market = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/market-api.html`,
  "name": "行情數據",
  "content": MarketContent
}
const Trade = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trade-api.html`,
  "name": "交易接口",
  "content": TradeContent
}
export const cswapConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Description,
  Authentication,
  Basic,
  Market,
  Trade,
  Socket,
]


// WEBPACK FOOTER //
// ./src/config/zh-tw/cswap/index.js